import React from 'react';
import {connect } from 'react-redux'
import FilterContainer from './FilterContainer';
import VideoPlayer from './VideoPlayer';
import Timeline from './Timeline';
import CardsContainer from './CardsContainer';

const Playback = () => {

  return (
    <div style={styles.container}>
      <div style={styles.leftContainer}>
        <FilterContainer />
        <VideoPlayer />
      </div>
      <div style={styles.rightContainer}>
        <Timeline />
        <CardsContainer />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {}
}
export default connect(mapStateToProps)(Playback)

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '2vw',
    width: '75vw',
    padding: '1vw',
    border: '2px solid gray',
    borderRadius: 5,
    backgroundColor: 'rgba(10, 14, 25, 0.6)',
    color: 'white',
    fontSize: '1.4vmin',
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '55vw',
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5vw',
    width: '16vw',
  },
}